import { Link } from "react-router-dom";
import { Feather } from "lucide-react";

export const Brand = () => (
  <Link to="/" className="brand" data-testid="brand-link">
    <span className="brand-mark"><Feather size={18} /></span>
    <span>
      <span className="brand-name">VOANDO<b>LIVRE</b></span>
      <span className="brand-sub mono">monitoramento ao vivo</span>
    </span>
  </Link>
);
